import type { EnrollmentOutcome } from "@/helpers/enrollmentOutcome";

import { SettingsBanner } from "./SettingsBanner";

type EnrollmentOutcomeBannerProps = {
  outcome: EnrollmentOutcome;
  onDismiss: () => void;
  onSetUpAgain?: () => void;
};

/**
 * Shown when a co-signing setup this browser was following ended before
 * co-signing turned on: the Stellar transaction failed, the invitation
 * expired, or the other Owner cancelled. The backend does not say which.
 */
export const EnrollmentOutcomeBanner = ({
  outcome,
  onDismiss,
  onSetUpAgain,
}: EnrollmentOutcomeBannerProps) => {
  const withWhom = outcome.owner2Name ? ` with ${outcome.owner2Name}` : "";
  return (
    <SettingsBanner
      variant="error"
      title="Co-signing setup didn't finish"
      onDismiss={onDismiss}
      actions={onSetUpAgain ? [{ label: "Set up again", onClick: onSetUpAgain }] : undefined}
      className="EnrollmentOutcomeBanner"
    >
      The setup{withWhom} ended before co-signing turned on, so nothing changed and disbursements
      still need one approval. This happens when the invitation expires, the other Owner cancels, or
      the Stellar network rejects the change. You can start again.
    </SettingsBanner>
  );
};
